import { notification } from "ant-design-vue";
import YwIcon from "../icon/index";
import "./src/notification.less"
const { ...other } = notification;
// const iconNodesuccess=(h)=>(
// 	<YwIcon iconClass="xian16-xiazai" color="#EFF9F5" size="24"/>
// );
// const iconNodeerror=(h)=>(
// 	<YwIcon iconClass="close-circle-filled" color="#FDF1EF" size="24"/>
// );
// const iconNodeinfo=(h)=>(
// 	<YwIcon iconClass="jinggaotishi-mianxing" color="#EEF7FE" size="24"/>
// );
// const iconNodewarning=(h)=>(
// 	<YwIcon iconClass="jinggaotishi-mianxing" color="#FFFBEB" size="24"/>
// );
const YwNotification = {
	...other,
	name: "YwNotification",
	success: (config) => {
		const { icon, style, ...otherArgs } = config;
		notification.success({
			style: {
				background: "#EFF9F5",
			},
			icon: (h) => (
				<YwIcon
					iconClass="check-circle-filled"
					size="24"
					color="#4BC398"
				></YwIcon>
			),
			...otherArgs,
			//   icon:iconNodesuccess,
		});
	},
	warning(config) {
		notification.warning({
			style: {
				background: "#FFFBEB",
			},
			// icon:iconNodewarning,
			icon: (h) => (
				<YwIcon
					iconClass="check-circle-filled"
					size="24"
					color="#7BBCFB"
				></YwIcon>
			),
			...config,
		});
	},
	info(config) {
		notification.info({
			style: {
				background: "#EEF7FE",
			},
			// icon:iconNodeinfo,
			icon: (h) => (
				<YwIcon
					iconClass="check-circle-filled"
					size="24"
					color="#FFD666 "
				></YwIcon>
			),
			...config,
		});
	},
	error(config) {
		notification.error({
			style: {
				background: "#FDF1EF",
			},
			// icon:iconNodeerror,
			icon: (h) => (
				<YwIcon
					iconClass="check-circle-filled"
					size="24"
					color="#EB3A36"
				></YwIcon>
			),
			...config,
		});
	},
};

YwNotification.install = function (Vue) {
	Vue.use(YwIcon);
	Vue.component(YwNotification.name, YwNotification);
	Vue.prototype.$ywNotification = YwNotification;
};
export default YwNotification;
